import api from "./client";

export type SyncKind = "realtime" | "backfill";
export type SyncStatus = "running" | "success" | "error";

export interface SyncRun {
  id: number;
  kind: SyncKind;
  status: SyncStatus;
  started_at: string;
  finished_at: string | null;
  date_window_start: string | null;
  date_window_end: string | null;
  pages_fetched: number;
  new_leads: number;
  updated_leads: number;
  error_message: string | null;
}

export interface RealtimeConfig {
  poll_interval_seconds: number;
  lookback_days: number;
  max_pages_per_run: number;
  active: boolean;
}

export async function listSyncRuns(
  kind?: SyncKind,
  limit = 50,
): Promise<SyncRun[]> {
  const params: Record<string, string | number> = { limit };
  if (kind) params.kind = kind;
  const { data } = await api.get<SyncRun[]>("/api/sync-runs", { params });
  return data;
}

export async function getRealtimeConfig(): Promise<RealtimeConfig> {
  const { data } = await api.get<RealtimeConfig>(
    "/api/sync-runs/realtime/config",
  );
  return data;
}

export async function runRealtimeNow(): Promise<{ message: string }> {
  const { data } = await api.post<{ message: string }>(
    "/api/sync-runs/realtime/run-now",
    {},
  );
  return data;
}
